import styled from 'styled-components';

import { brand } from 'theme/colors';
import { fontSize, space, container } from 'theme/sizes';

export const Wrapper = styled.section`
  max-width: ${container.xsmall};
  margin: ${space.m} auto ${space.m};
  display: flex;
  align-items: center;
  justify-content: center;

  form {
    width: 100%;
    padding: 0 ${space.xs};

    .form__row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
    }

    button {
      margin-left: auto;
    }
  }
`;
